import React from 'react';
import PropTypes from 'prop-types';
import Button from './button';
import isEnterOrSpace from '../../../../helpers/isEnterOrSpace';

// TODO: Collapse button components - wrapper can be eliminated
const CustomButton = ({
  className,
  eventAction,
  label,
  loader,
}) => (
  <Button
    loader={loader}
    label={label}
    onKeyPress={event => isEnterOrSpace(event) && eventAction()}
    onClick={eventAction}
    className={className}
  />
);

CustomButton.propTypes = {
  className: PropTypes.string.isRequired,
  eventAction: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.array]).isRequired,
  loader: PropTypes.bool,
};

CustomButton.defaultProps = {
  loader: false,
};

export default CustomButton;
